import * as React from "react";
import { Context } from "@grandvisionhq/carts-v2";
import { useSelector, useDispatch } from "@grandvisionhq/state";
import { selectShippingMethod } from "../../../../StepShipping/StepShipping/actions.js";
import { getSelectedShippingMethod } from "../../../../StepShipping/StepShipping/selectors.js";
const useSyncCartShippingMethodWithReduxAfterTabFocus = () => {
  const [hasRefocussed, setHasRefocussed] = React.useState(false);
  const shippingMethod = useSelector(getSelectedShippingMethod);
  const { cart, refetch } = Context.useCart();
  const dispatch = useDispatch();
  React.useEffect(() => {
    const cb = () => {
      setHasRefocussed(document.visibilityState === "visible");
      if (document.visibilityState === "visible") {
        refetch();
      }
    };
    document.addEventListener("visibilitychange", cb);
    return () => {
      document.removeEventListener("visibilitychange", cb);
    };
  });
  React.useEffect(() => {
    if (hasRefocussed && shippingMethod?.method !== cart?.shippingMethod.key) {
      dispatch(
        selectShippingMethod({
          shippingMethod: {
            method: cart?.shippingMethod.key,
            isValid: true,
            isTouched: true
          }
        })
      );
    }
  }, [cart?.shippingMethod.key, dispatch, shippingMethod?.method, hasRefocussed]);
};
export {
  useSyncCartShippingMethodWithReduxAfterTabFocus
};
//# sourceMappingURL=use-sync-cart-shipping-method-with-redux.js.map
